// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YRGe","type":"styles_type__2Ux8R","choices":"styles_choices__3R3hs"};